import React, { useEffect, useState, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card, CardBody, Col, Container, Row, Spinner, Button,
  Modal, ModalHeader, ModalBody, Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import moment from "moment";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const API_BASE = "https://maasradarapi.stechomeyazilim.info";

const ReportsList = () => {
  document.title = "Raporlar | Maaş Radar Admin Paneli";

  const [activeTab, setActiveTab] = useState("comments");
  const [commentReports, setCommentReports] = useState([]);
  const [postReports, setPostReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState({});

  const [detailModal, setDetailModal] = useState(false);
  const [detailItem, setDetailItem] = useState(null);

  function getAuthHeaders() {
    const token = localStorage.getItem("token");
    return { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" };
  }

  const fetchItems = async () => {
    try {
      setLoading(true);
      const [commentsRes, postsRes] = await Promise.allSettled([
        axios.get(`${API_BASE}/ReportedComments?$orderby=CreatedAt desc&$top=200`, { headers: getAuthHeaders() }),
        axios.get(`${API_BASE}/ReportedPosts?$orderby=CreatedAt desc&$top=200`, { headers: getAuthHeaders() }),
      ]);
      setCommentReports(commentsRes.status === "fulfilled" ? (commentsRes.value.data.value || []) : []);
      setPostReports(postsRes.status === "fulfilled" ? (postsRes.value.data.value || []) : []);
    } catch (error) {
      console.error("Veriler alınamadı", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  const showToast = (success, message) => {
    toastr.options = { positionClass: "toast-top-right", timeOut: 5000, closeButton: true, progressBar: true };
    if (success) toastr.success(message, "Başarılı");
    else toastr.error(message, "Hata");
  };

  const handleDeleteCommentReport = (id) => {
    if (!window.confirm("Bu raporu silmek istediğinize emin misiniz?")) return;
    setProcessing(p => ({ ...p, [id + "delete"]: true }));
    axios.delete(`${API_BASE}/ReportedComments(${id})`, { headers: getAuthHeaders() })
      .then(() => { showToast(true, "Rapor silindi."); fetchItems(); })
      .catch((err) => { console.error(err); showToast(false, "Silme sırasında hata oluştu."); })
      .finally(() => setProcessing(p => ({ ...p, [id + "delete"]: false })));
  };

  const handleDeletePostReport = (id) => {
    if (!window.confirm("Bu raporu silmek istediğinize emin misiniz?")) return;
    setProcessing(p => ({ ...p, [id + "deletePost"]: true }));
    axios.delete(`${API_BASE}/ReportedPosts(${id})`, { headers: getAuthHeaders() })
      .then(() => { showToast(true, "Rapor silindi."); fetchItems(); })
      .catch((err) => { console.error(err); showToast(false, "Silme sırasında hata oluştu."); })
      .finally(() => setProcessing(p => ({ ...p, [id + "deletePost"]: false })));
  };

  const openDetail = (item) => { setDetailItem(item); setDetailModal(true); };

  const commentColumns = useMemo(() => [
    { Header: "ID", accessor: "Id", width: "80px" },
    { Header: "Yorum ID", accessor: "CommentId" },
    { Header: "Rapor Eden", accessor: "ReportedByUserId" },
    { Header: "Neden", accessor: "Reason" },
    { Header: "Tarih", accessor: "CreatedAt", Cell: ({ value }) => value ? moment(value).format("DD.MM.YYYY") : "-" },
    {
      Header: "İşlemler", accessor: "actions", disableSortBy: true,
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Button size="sm" color="info" onClick={() => openDetail(row.original)}>Detay</Button>
          <Button size="sm" color="danger" disabled={processing[row.original.Id + "delete"]} onClick={() => handleDeleteCommentReport(row.original.Id)}>
            {processing[row.original.Id + "delete"] ? <Spinner size="sm" /> : "Sil"}
          </Button>
        </div>
      )
    }
  ], [processing]);

  const postColumns = useMemo(() => [
    { Header: "ID", accessor: "Id", width: "80px" },
    { Header: "Gönderi ID", accessor: "PostId" },
    { Header: "Rapor Eden", accessor: "ReportedByUserId" },
    { Header: "Neden", accessor: "Reason" },
    { Header: "Tarih", accessor: "CreatedAt", Cell: ({ value }) => value ? moment(value).format("DD.MM.YYYY") : "-" },
    {
      Header: "İşlemler", accessor: "actions", disableSortBy: true,
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Button size="sm" color="info" onClick={() => openDetail(row.original)}>Detay</Button>
          <Button size="sm" color="danger" disabled={processing[row.original.Id + "deletePost"]} onClick={() => handleDeletePostReport(row.original.Id)}>
            {processing[row.original.Id + "deletePost"] ? <Spinner size="sm" /> : "Sil"}
          </Button>
        </div>
      )
    }
  ], [processing]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Raporlar" breadcrumbItem="Liste" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Nav tabs>
                    <NavItem>
                      <NavLink className={activeTab === "comments" ? "active" : ""} onClick={() => setActiveTab("comments")}>Yorum Raporları</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={activeTab === "posts" ? "active" : ""} onClick={() => setActiveTab("posts")}>Gönderi Raporları</NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="comments">
                      {loading ? (
                        <div className="text-center py-5"><Spinner color="primary" /></div>
                      ) : (
                        <TableContainer columns={commentColumns} data={commentReports} isGlobalFilter={true} isAddOptions={false} customPageSize={10} className="custom-header-css" />
                      )}
                    </TabPane>
                    <TabPane tabId="posts">
                      {loading ? (
                        <div className="text-center py-5"><Spinner color="primary" /></div>
                      ) : (
                        <TableContainer columns={postColumns} data={postReports} isGlobalFilter={true} isAddOptions={false} customPageSize={10} className="custom-header-css" />
                      )}
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={detailModal} toggle={() => setDetailModal(false)} size="lg">
        <ModalHeader toggle={() => setDetailModal(false)}>Rapor Detayı</ModalHeader>
        <ModalBody>
          {detailItem && (
            <div>
              <p><strong>ID:</strong> {detailItem.Id}</p>
              <p><strong>Neden:</strong> {detailItem.Reason || "-"}</p>
              <p><strong>Tarih:</strong> {detailItem.CreatedAt ? moment(detailItem.CreatedAt).format("DD.MM.YYYY HH:mm") : "-"}</p>
            </div>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(ReportsList);
